<!-- src/components/invoices/PartyFormFields.vue -->
<template>
    <div class="row g-2">
        <div class="col-12" v-if="showGus || showMyData">
            <label class="form-label small mb-1">NIP</label>
            <div class="input-group input-group-sm">
                <input type="text" class="form-control" v-model="party.nip" placeholder="NIP" />
                <button v-if="showGus" class="btn btn-outline-secondary" type="button" @click="$emit('fetchGus')">
                    Pobierz GUS
                </button>
                <button v-if="showMyData" class="btn btn-outline-primary" type="button" @click="$emit('fetchMyData')">
                    Moje dane
                </button>
            </div>
        </div>
        <div class="col-12"><label class="form-label small mb-1">Nazwa firmy</label><input type="text"
                class="form-control form-control-sm" v-model="party.companyName" /></div>
        <div class="col-6"><label class="form-label small mb-1">Imię</label><input type="text"
                class="form-control form-control-sm" v-model="party.firstName" /></div>
        <div class="col-6"><label class="form-label small mb-1">Nazwisko</label><input type="text"
                class="form-control form-control-sm" v-model="party.lastName" /></div>
        <div class="col-6">
            <label class="form-label small mb-1">Kraj</label>
            <select class="form-select form-select-sm" v-model="party.country">
                <!-- Opcja domyślna / pusta, jeśli potrzebna -->
                <option value="" disabled>-- Wybierz kraj --</option>

                <!-- Pętla po nowej tablicy obiektów -->
                <option v-for="c in countries" :key="c.name" :value="c.name">
                    {{ c.name }}
                </option>
            </select>
        </div>
        <div class="col-6"><label class="form-label small mb-1">Kod pocztowy</label><input type="text"
                class="form-control form-control-sm" v-model="party.postalCode" /></div>
        <div class="col-6"><label class="form-label small mb-1">Miasto</label><input type="text"
                class="form-control form-control-sm" v-model="party.city" /></div>
        <div class="col-6"><label class="form-label small mb-1">Ulica i nr</label><input type="text"
                class="form-control form-control-sm" v-model="party.street" /></div>
        <div class="col-6"><label class="form-label small mb-1">E-mail</label><input type="email"
                class="form-control form-control-sm" v-model="party.email" /></div>
        <div class="col-6"><label class="form-label small mb-1">Telefon</label><input type="text"
                class="form-control form-control-sm" v-model="party.phone" /></div>
        <div class="col-6" v-if="!hidePersonalFields">
            <label class="form-label small mb-1">PESEL</label>
            <input type="text" class="form-control form-control-sm" v-model="party.pesel" />
            <div v-if="party.pesel && party.pesel.length > 0" class="mt-1">
                <small class="text-danger" v-if="!validatePESEL(party.pesel).valid">
                    <i class="bi bi-exclamation-circle me-1"></i>{{ validatePESEL(party.pesel).message }}
                </small>
                <small class="text-success" v-else>
                    <i class="bi bi-check-circle me-1"></i>Poprawny numer PESEL
                </small>
            </div>
        </div>
        <div class="col-6" v-if="!hidePersonalFields"><label class="form-label small mb-1">Seria i nr dowodu</label><input type="text"
                class="form-control form-control-sm" v-model="party.idCardSeriesNumber" /></div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { validatePESEL } from '@/utils/validators'

const props = defineProps({
    modelValue: { type: Object, required: true },
    countries: { type: Array, default: () => [] },
    showGus: { type: Boolean, default: false },
    showMyData: { type: Boolean, default: false },
    hidePersonalFields: { type: Boolean, default: false } 
})

const emit = defineEmits(['update:modelValue', 'fetchGus', 'fetchMyData'])

const party = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})
</script>